module.exports = __webpack_public_path__ + "01_short_black.b3d83c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_short_black.png
// module id = 7z+7
// module chunks = 0